import React from "react";
import "./Help.css";
import { Modal } from "react-bootstrap";

export default function Help(props) {
  const showModalHandler = () => {
    props.onShow();
  };

  const handleClose = () => {
    props.onHide();
  };

  return (
    <div>
      <div className="questionWrapper centeredFlex" onClick={showModalHandler}>
        <img src="/images/questionMark.svg" alt="question" />
      </div>
      <Modal
        show={props.showQuestionModal}
        dialogClassName="questionModal centeredFlex"
        contentClassName="customModalContent"
        onHide={handleClose}
      >
        <div className="modalQuestionWrapper centeredFlex">
          <img src="/images/questionMark.svg" alt="question" />
        </div>
        {props.data.map((item) => (
          <div className="questionModalText" key={item.id}>
            <div className="pinkSquare"></div>
            <p>{item.text}</p>
          </div>
        ))}
      </Modal>
    </div>
  );
}
